import videojs from 'video.js';
import 'videojs-landscape-fullscreen';
import 'video.js/dist/video-js.css';

/**
 * @param el
 * @param offset
 * @returns {boolean}
 */
function creativeIsScrolledIntoView(el, offset) {
    let rect = el.getBoundingClientRect();
    let elemTop = rect.top + offset;
    let elemBottom = rect.bottom;

    return elemTop < window.innerHeight && elemBottom >= 0;
}

/**
 * @param element
 * @param c
 */
function creativeAddClasses(element, c) {
    for (let i = 0; i < c.length; i++) {
        element.classList.add(c[i]);
    }
}

/**
 * @returns {boolean}
 */
const creativeIsMobile = () => {
    return window.innerWidth < 720;
};

/**
 * @param {HTMLElement|Node} element
 * @param {string} className
 * @param {boolean} returnParent
 * @returns {boolean|HTMLElement|Node}
 */
const creativeHasParentClass = (element, className, returnParent = false) => {
    do {
        if (element.classList && element.classList.contains(className)) {
            if (returnParent) {
                return element;
            }
            return true;
        }
        element = element.parentNode;
    } while (element);

    return false;
}

window.addEventListener('DOMContentLoaded', () => {
    // Animate home boxes.
    (() => {
        let classes = ['animate__animated',  'animate__fadeIn'];

        let elements = document.querySelectorAll('.home-box');
        elements.forEach((element) => {
            element.style.opacity = '0';
        });

        let checkElementsPosition = () => {
            elements.forEach((element) => {
                if (creativeIsScrolledIntoView(element, 0)) {
                    creativeAddClasses(element, classes);
                }
            });
        }

        checkElementsPosition();
        window.addEventListener('scroll', checkElementsPosition);

        /*if (element) {
            element.style.opacity = '0';

            let checkPosition = function() {
                if (isScrolledIntoView(element, -200)) {
                    addClasses(element, classes);
                }
            }

            checkPosition();
            window.addEventListener('scroll', checkPosition);
        }*/
    })();

    // Animate home FAQ.
    (() => {
        let classes = ['animate__animated', 'animate__slideInUp'];

        let element = document.querySelector('.home-faq');
        if (element) {
            let children = element.querySelectorAll('li');
            children.forEach((child, i) => {
                // child.style.opacity = '0';
                child.style.animationDelay = (50 * i) + 'ms';
            });

            let checkElementsPosition = () => {
                if (creativeIsScrolledIntoView(element, 0)) {
                    children.forEach((child) => {
                        creativeAddClasses(child, classes);
                    });
                }
            }

            window.addEventListener('scroll', checkElementsPosition);
        }
    })();

    // Animate home testimonial.
    (() => {
        let elements = document.querySelectorAll('.home-box-testimonial');
        for (let i = 0; i < elements.length; i++) {
            if (!creativeIsScrolledIntoView(elements[i], -100)) {
                // elements[i].style.opacity = '0';
            }
        }

        let classes = ['animate__animated', 'animate__slideInUp'];

        let checkPosition = () => {
            for (let i = 0; i < elements.length; i++) {
                if (creativeIsScrolledIntoView(elements[i], 0)) {
                    creativeAddClasses(elements[i], classes);
                }
            }
        }

        checkPosition();
        window.addEventListener('scroll', checkPosition);
    })();

    // Handle popup video player.
    (() => {
        const wrappers = document.querySelectorAll('.creative-inline-video-thumb');
        wrappers.forEach((wrap) => {
            const popupSelector = wrap.getAttribute('data-popup-selector');
            const playerSelector = wrap.getAttribute('data-player-selector');

            let poster = '';
            const sources = [];
            if (creativeIsMobile()) {
                poster = wrap.getAttribute('data-poster-mobile');
                sources.push({
                    src: wrap.getAttribute('data-src-mobile'),
                    type: 'video/mp4'
                });
            } else {
                poster = wrap.getAttribute('data-poster-desktop');
                sources.push({
                    src: wrap.getAttribute('data-src-desktop'),
                    type: 'video/mp4'
                });
            }
            if (!poster || sources.length === 0) {
                return;
            }

            const playButton = wrap.querySelector('.fa');
            if (playButton) {
                playButton.addEventListener('click', () => {
                    const popup = document.getElementById(popupSelector).cloneNode(true);
                    const mask = document.createElement('div');
                    mask.classList.add('creative-video-mask', 'animate__animated', 'animate__fadeIn');
                    mask.appendChild(popup);
                    document.body.appendChild(mask);

                    mask.addEventListener('click', (e) => {
                        if (!creativeHasParentClass(e.target, 'creative-video-popup')) {
                            mask.classList.remove('animate__fadeIn');
                            mask.classList.add('animate__fadeOut');
                            popup.classList.add('animate__animated', 'animate__zoomOut');
                            setTimeout(() => {
                                mask.remove();
                            }, 1000);
                        }
                    });

                    const player = videojs(popup.querySelector(playerSelector), {
                        responsive: true,
                        controls: creativeIsMobile(),
                        fill: true,
                        poster,
                        sources
                    });
                    player.landscapeFullscreen({
                        fullscreen: {
                            enterOnRotate: true,
                            exitOnRotate: true,
                            alwaysInLandscapeMode: false,
                            iOS: false
                        }
                    });
                    setTimeout(() => {
                        player.play();
                    }, 1000);
                });
            }
        });
    })();

    // Add play button to supported videos.
    (() => {
        let wrap = document.querySelector('.work-video-wrap,.home-video-wrap');
        if (wrap) {
            let poster = '';
            const sources = [];
            if (creativeIsMobile()) {
                poster = wrap.getAttribute('data-poster-mobile');
                sources.push({
                    src: wrap.getAttribute('data-src-mobile'),
                    type: 'video/mp4'
                });
                const btn = document.createElement('i');
                btn.classList.add('fa', 'fa-solid', 'fa-circle-play', 'video-play-button');
                wrap.appendChild(btn);
            } else {
                poster = wrap.getAttribute('data-poster-desktop');
                sources.push({
                    src: wrap.getAttribute('data-src-desktop'),
                    type: 'video/mp4'
                });
            }

            const player = videojs('hero-video', {
                responsive: true,
                controls: false,
                fluid: true,
                poster,
                sources,
            });
            if (wrap.getAttribute('data-auto-play') === 'true') {
                player.autoplay('muted');
            }

            let playButton = wrap.querySelector('.fa');
            let isVideoPlaying = false;

            player.on('play', () => {
                if (playButton) {
                    playButton.style.display = 'none';
                }
            });

            player.on('pause', () => {
                if (playButton) {
                    playButton.style.display = 'block';
                }
            });

            /**
             * @param e
             */
            const togglePlaying = (e) => {
                e.stopPropagation();
                if (!isVideoPlaying) {
                    player.play();
                    isVideoPlaying = true;
                } else {
                    player.pause();
                    isVideoPlaying = false;
                }
            };

            wrap.addEventListener('click', togglePlaying);
            if (playButton) {
                playButton.addEventListener('click', togglePlaying);
            }
        }
    })();

    // Masonry.
    (() => {
        let grid = document.querySelector('.create-clients');
        if (grid) {
            let m = new Masonry(grid, {
                itemSelector: '.create-clients .create-client-col',
                columnWidth:     '.create-clients .grid-sizer',
                gutter:          '.create-clients .grid-gutter',
                percentPosition: true
            });
            imagesLoaded(grid, () => {
                m.layout();
            });
        }

        let homeGrid = document.querySelector('.home-clients');
        if (homeGrid) {
            new Masonry(homeGrid, {
                itemSelector: '.create-client-col',
                columnWidth:     '.grid-sizer',
                gutter:          '.grid-gutter',
                percentPosition: true
            });
        }

        const classes = ['animate__animated', 'animate__fadeIn'];
        let elements = [].slice.call(document.querySelectorAll('img[data-loading="lazy"]'));
        for (let i = 0; i < elements.length; i++) {
            elements[i].style.opacity = '0';
        }

        let checkElementsPosition = () => {
            let newElements = [];
            for (let i = elements.length - 1; i >= 0; i--) {
                if (creativeIsScrolledIntoView(elements[i], 0)) {
                    elements[i].setAttribute('src', elements[i].getAttribute('data-src'));
                    elements[i].removeAttribute('data-loading');
                    elements[i].removeAttribute('data-src');
                    creativeAddClasses(elements[i], classes);
                } else {
                    newElements.push(elements[i]);
                }
            }
            elements = newElements;
        }

        checkElementsPosition();
        window.addEventListener('scroll', checkElementsPosition);
        document.addEventListener('creative-changed', () => {
            elements = [].slice.call(document.querySelectorAll('img[data-loading="lazy"]'));
            checkElementsPosition();
        });
    })();

    // Filter clients on "What we create" page.
    (() => {
        let lists = document.querySelectorAll('.create-layout-sidebar-list');
        if (lists.length === 0) {
            return;
        }

        // https://icons8.com/cssload/en/spinners
        let loader = document.querySelector('.creative-loader');
        const trigger = document.querySelector('.create-layout-mobile-filters-trigger .fa');
        const inline = document.querySelector('.create-layout-sidebar-list-inline');
        const inner = document.querySelector('.create-layout-mobile-filters');

        /**
         * @param data
         */
        const loadCategories = (data) => {
            let body = document.querySelector('.create-body');
            body.classList.add('animate__animated', 'animate__faster', 'animate__fadeOut');
            setTimeout(() => {
                wp.ajax.post('creative_filter', data)
                    .done((response) => {
                        body.innerHTML = response;
                        setTimeout(() => {
                            let grid = document.querySelector('.create-clients');
                            if (grid) {
                                let m = new Masonry(grid, {
                                    itemSelector: '.create-clients .create-client-col',
                                    columnWidth:     '.create-clients .grid-sizer',
                                    gutter:          '.create-clients .grid-gutter',
                                    percentPosition: true
                                });
                                imagesLoaded(grid, function() {
                                    m.layout();
                                    body.classList.add('animate__fadeIn');
                                    body.classList.remove('animate__fadeOut');
                                });
                                document.dispatchEvent(new Event('creative-changed'));
                            }
                        }, 250);
                    })
                    .always(function() {
                        setTimeout(function() {
                            loader.style.display = 'none';
                        }, 500);
                    });
            }, 500);
        };

        /**
         *
         */
        const filterPage = () => {
            loader.style.display = 'flex';
            inner.classList.remove('opened');
            const data = {
                categories: []
            }

            for (let i = 0; i < lists.length; i++) {
                lists[i].querySelectorAll('input[type="checkbox"]').forEach((el) => {
                    if (el.checked) {
                        const val = el.getAttribute('value');
                        if (data.categories.indexOf(val) === -1) {
                            data.categories.push(val);
                        }
                    }
                });
            }
            loadCategories(data);
        };

        /**
         * @param e
         */
        const handleCheckboxChange = (e) => {
            if (e.target.checked) {
                const clone = e.target.closest('li').cloneNode(true);
                inline.appendChild(clone);
            } else {
                const clone = inline.querySelector(`.create-filter-list-item-${e.target.value}`);
                if (clone) {
                    clone.remove();
                }
            }

            document.querySelectorAll(`.create-filter-list-item-${e.target.value} input`).forEach((el) => {
                el.checked = e.target.checked;
            });

            filterPage();
            wireupLists();
        };

        /**
         *
         */
        const wireupLists = () => {
            lists = document.querySelectorAll('.create-layout-sidebar-list');
            for (let i = 0; i < lists.length; i++) {
                const list = lists[i];
                list.querySelectorAll('input[type="checkbox"]').forEach((el) => {
                    el.removeEventListener('change', handleCheckboxChange);
                    el.addEventListener('change', handleCheckboxChange);
                });
            }
        }

        trigger.addEventListener('click', () => {
            if (inner.classList.contains('opened')) {
                inner.classList.remove('opened');
            } else {
                inner.classList.add('opened');
            }
        });

        wireupLists();

        /*let filterList = document.querySelector('.create-filter-list');
        if (filterList) {
            let servicesList = document.querySelector('.create-services-list');

            let updatePage = () => {
                loader.style.display = 'flex';
                const data = {
                    categories: []
                }
                filterList.querySelectorAll('input[type="checkbox"]').forEach((el) => {
                    if (el.checked) {
                        data.categories.push(el.getAttribute('value'));
                    }
                });
                servicesList.querySelectorAll('input[type="checkbox"]').forEach((el) => {
                    if (el.checked) {
                        el.getAttribute('value');
                    }
                });
                loadCategories(data);
            }

            filterList.querySelectorAll('input[type="checkbox"]').forEach(function(el) {
                el.addEventListener('change', updatePage);
            });
            servicesList.querySelectorAll('input[type="checkbox"]').forEach(function(el) {
                el.addEventListener('change', updatePage);
            });
        }*/
    })();

    // Expand and collapse home FAQ.
    (() => {
        let faq = document.querySelector('.home-faq');
        if (!faq) {
            return;
        }

        faq.querySelectorAll('.home-faq-answer').forEach((el) => {
            el.setAttribute('data-height', window.getComputedStyle(el).height);
            el.style.height = '0';
            let parent = el.closest('li');
            parent.classList.add('closed');
        });

        faq.querySelectorAll('.home-faq-trigger').forEach((el) => {
            let parent = el.closest('li');
            let answer = parent.querySelector('.home-faq-answer');
            el.addEventListener('click', function() {
                if (parent.classList.contains('closed')) {
                    answer.style.height = answer.getAttribute('data-height');
                    parent.classList.add('opened');
                    parent.classList.remove('closed');
                } else {
                    answer.style.height = '0';
                    parent.classList.add('closed');
                    parent.classList.remove('opened');
                }
            });
        });
    })();

    // Scroll in contact form.
    (() => {
        let formContact = document.querySelector('.form-contact');

        let scrollForm = function() {
            let top = (window.innerHeight + window.scrollY) + 'px';

            let formClone = formContact.cloneNode(true);
            formClone.style.transform = 'translateY(' + top + ')';
            formClone.classList.add('clone');

            let closeBtn = document.createElement('i');
            closeBtn.classList.add('fa-solid', 'fa-xmark');
            closeBtn.addEventListener('click', function() {
                formClone.classList.add('animate__animated', 'animate__fadeOut');
                setTimeout(function() {
                    formClone.remove();
                }, 1000);
            });
            formClone.appendChild(closeBtn);

            document.body.append(formClone);
            setTimeout(function() {
                formClone.style.transform = 'translateY(' + (window.scrollY - 80) + 'px)';
            }, 10);
        }

        let workLink = document.querySelector('.nav-work-with-us');
        if (workLink && formContact) {
            workLink.addEventListener('click', function(e) {
                e.preventDefault();
                /*formContact.scrollIntoView({
behavior: 'smooth',
});*/
                scrollForm();
            });
        }

        let formLink = document.querySelector('.home-box .form-contact-btn');
        if (formLink && formContact) {
            formLink.addEventListener('click', function(e) {
                e.preventDefault();
                /*formContact.scrollIntoView({
                    behavior: 'smooth',
                });*/
                scrollForm();
            });
        }

        let navLink = document.querySelector('.nav-item-work-with-us');
        if (navLink && formContact) {
            navLink.addEventListener('click', function(e) {
                e.preventDefault();
                /*formContact.scrollIntoView({
                    behavior: 'smooth',
                });*/
                scrollForm();
            });
        }
    })();

    /**
     * Handles submitting the contact form.
     *
     * @param e
     */
    window.creativeFormSubmit = (e) => {
        e.preventDefault();
        if (!window.hubspotPortalID || !window.hubspotFormGUID) {
            console.error('Hubspot portal ID or form GUID not set.');
            return;
        }

        let form = e.target;
        let btn = form.querySelector('button');
        btn.setAttribute('disabled', 'true');

        const serializeForm = () => {
            let obj = {
                industry: '',
            };
            let formData = new FormData(form);
            for (let key of formData.keys()) {
                if (key === 'interests[]') {
                    obj.industry = formData.getAll(key).join(',');
                } else {
                    obj[key] = formData.get(key);
                }
            }

            return obj;
        };

        const context = {
            pageUri: document.location.href,
            ipAddress: window.visitorIP,
            pageName: document.title,
        };
        const hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        if (hutk) {
            context.hutk = hutk;
        }

        let formData = serializeForm(e.target);
        let data = {
            submittedAt: Date.now(),
            context,
            fields: [],
        };
        Object.keys(formData).forEach((key) => {
            data.fields.push({
                objectTypeId: '0-1',
                name: key,
                value: formData[key],
            });
        });

        fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${window.hubspotPortalID}/${window.hubspotFormGUID}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then((resp) => resp.json())
            .then(() => {
                document.location = '/thank-you';
            });
    }
});
